import React, { useState, useEffect } from 'react';

function UserSettingsForm({ settings, onSave }) {
  const [form, setForm] = useState({
    testrailUrl: '',
    testrailUsername: '',
    testrailApiKey: '',
    defaultProjectId: '',
    defaultSectionId: '',
    defaultSuiteId: ''
  });
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    if (settings) {
      setForm({
        testrailUrl: settings.testrailUrl || '',
        testrailUsername: settings.testrailUsername || '',
        testrailApiKey: settings.testrailApiKey || '',
        defaultProjectId: settings.defaultProjectId || '',
        defaultSectionId: settings.defaultSectionId || '',
        defaultSuiteId: settings.defaultSuiteId || ''
      });
    }
  }, [settings]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setFeedback(null);
    try {
      await onSave(form);
      setFeedback({ type: 'success', message: 'Settings saved successfully.' });
    } catch (err) {
      setFeedback({ type: 'error', message: `Failed to save settings: ${err.message}` });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-form-container">
      <h3>TestRail Settings</h3>
      {feedback && (
        <div className={`settings-feedback ${feedback.type === 'success' ? 'settings-feedback-success' : 'settings-feedback-error'}`} role="status">
          {feedback.message}
        </div>
      )}
      <form onSubmit={handleSubmit} className="settings-form">
        <div className="settings-field">
          <label htmlFor="testrailUrl">TestRail URL</label>
          <input id="testrailUrl" name="testrailUrl" className="input" type="text" value={form.testrailUrl} onChange={handleChange} placeholder="https://testrail.example.com" />
        </div>
        <div className="settings-field">
          <label htmlFor="testrailUsername">Username</label>
          <input id="testrailUsername" name="testrailUsername" className="input" type="text" value={form.testrailUsername} onChange={handleChange} placeholder="your-email@example.com" />
        </div>
        <div className="settings-field">
          <label htmlFor="testrailApiKey">API Key</label>
          <input id="testrailApiKey" name="testrailApiKey" className="input" type="password" value={form.testrailApiKey} onChange={handleChange} placeholder="Enter API key" />
        </div>
        <div className="settings-row">
          <div className="settings-field">
            <label htmlFor="defaultProjectId">Default Project ID</label>
            <input id="defaultProjectId" name="defaultProjectId" className="input" type="text" value={form.defaultProjectId} onChange={handleChange} placeholder="e.g. 5" />
          </div>
          <div className="settings-field">
            <label htmlFor="defaultSectionId">Default Section ID</label>
            <input id="defaultSectionId" name="defaultSectionId" className="input" type="text" value={form.defaultSectionId} onChange={handleChange} placeholder="e.g. 283" />
          </div>
          <div className="settings-field">
            <label htmlFor="defaultSuiteId">Default Suite ID</label>
            <input id="defaultSuiteId" name="defaultSuiteId" className="input" type="text" value={form.defaultSuiteId} onChange={handleChange} placeholder="e.g. 14" />
          </div>
        </div>
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? 'Saving...' : 'Save Settings'}
        </button>
      </form>
    </div>
  );
}

export default UserSettingsForm;
